import { render, staticRenderFns } from "./PlantContratoIndex.vue?vue&type=template&id=15221fbc"
import script from "./PlantContratoIndex.vue?vue&type=script&lang=js"
export * from "./PlantContratoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports